import { createRoute } from "@tanstack/react-router";
import { AccountSecurityPage } from "@/features/account/AccountSecurityPage";
import { staffRoute } from "@/routes/staff";

export const accountSecurityRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "account/security",
  component: AccountSecurityPage,
});
